import type { CompanyType } from "@entrilia/shared/api/clientTypes";
import type { DemoRefreshOperation, DemoRefreshStatus } from "../../../../api/types/demoRefreshTypes";

interface DemoRefreshCompany {
  featureEnabled: boolean;
  companyType: CompanyType;
  sourceTemplateClientCode: string | undefined;
}

export const getDemoRefreshTemplateCode = ({
  featureEnabled,
  companyType,
  sourceTemplateClientCode,
}: DemoRefreshCompany): string | undefined =>
  featureEnabled && companyType === "Demo" && sourceTemplateClientCode ? sourceTemplateClientCode : undefined;

export const isDemoRefreshRunning = (operation: DemoRefreshOperation | undefined): boolean =>
  operation !== undefined && operation.completedAt === undefined;

export const getDemoRefreshStageLabel = (status: DemoRefreshStatus): string | undefined => {
  switch (status) {
    case "Created":
    case "Validating":
    case "PrerequisitesPassed":
      return "checking the prerequisites";
    case "Exporting":
    case "Exported":
      return "exporting the template company";
    case "Importing":
    case "Imported":
      return "loading the accounting data";
    case "Resyncing":
      return "syncing platform data";
    case "Synced":
    case "Failed":
      return undefined;
  }
};
